import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { inserirRedutor, atualizarRedutor } from '~/Services/Service';

const schema = Yup.object().shape({
  descricao: Yup.string().max(30, 'Máximo 30 caracteres'),
  percentual: Yup.number().typeError('Informe um número'),
  fator: Yup.number()
    .typeError('Informe um número')
    .required('Fator obrigatório')
    .moreThan(0, 'Fator inválido'),
});

const ModalRedutor = ({ show, onHide, redutor, onSalvar }) => {
  const codigoEdicao = redutor != null ? parseInt(redutor.codigo, 10) : NaN;
  const isEdicao = !Number.isNaN(codigoEdicao) && codigoEdicao > 0;

  const initialValues = {
    codigo: isEdicao ? codigoEdicao : null,
    descricao: isEdicao ? (redutor.descricao || '') : '',
    percentual: isEdicao ? redutor.percentual : '',
    fator: isEdicao ? redutor.fator : '',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        descricao: values.descricao,
        percentual: parseFloat(values.percentual) || 0,
        fator: parseFloat(values.fator),
      };
      if (isEdicao) {
        const codigo = parseInt(values.codigo, 10);
        if (Number.isNaN(codigo) || codigo <= 0) {
          toast.error('Código do redutor inválido para edição.');
          setSubmitting(false);
          return;
        }
        payload.codigo = codigo;
        await atualizarRedutor(payload);
        toast.success('Redutor atualizado com sucesso!');
      } else {
        await inserirRedutor(payload);
        toast.success('Redutor incluído com sucesso!');
      }
      onSalvar();
    } catch (err) {
      toast.error(err && err.message ? err.message : 'Erro ao salvar redutor');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#0747a6', color: '#fff' }}
        className="modal-header-blue"
      >
        <Modal.Title style={{ color: '#fff', fontSize: '1.1rem' }}>
          {isEdicao ? `Editar Redutor — Código ${codigoEdicao}` : 'Novo Redutor'}
        </Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit: formSubmit, isSubmitting }) => (
          <form onSubmit={formSubmit}>
            <Modal.Body>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">Descrição</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="descricao"
                  value={values.descricao}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.descricao && !!errors.descricao}
                  maxLength={30}
                />
                <Form.Control.Feedback type="invalid">{errors.descricao}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">% de Redução</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  name="percentual"
                  step="0.0001"
                  value={values.percentual}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.percentual && !!errors.percentual}
                />
                <Form.Control.Feedback type="invalid">{errors.percentual}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">Fator</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  name="fator"
                  step="0.0001"
                  value={values.fator}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.fator && !!errors.fator}
                />
                <Form.Control.Feedback type="invalid">{errors.fator}</Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </Button>
            </Modal.Footer>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalRedutor;
